import React from 'react';

import { Box, CssBaseline } from './shared/MaterialUI';
import { theme } from '../assets/theme';

const Footer = () => {
  const styles = useStyles();

  return (
    <>
      <CssBaseline />
      <Box component='footer' sx={styles.footer} />
    </>
  );
};

export default Footer;

const useStyles = () => ({
  footer: {
    width: '100%',
    height: '80px',
    backgroundColor: theme.palette.primary.black,
  },
});
